import React, { useContext } from "react";
import { AuthContext } from '../../contexts/AuthContext'
import { Col, Row, Button } from "reactstrap";
import Footer from "../../layout/Footer/Footer";
import Header from "../../layout/Header/Header";

function BotonesProduccion() {
  const { user } = useContext(AuthContext);
  return (
    <>
          <Header />
          {user.menu_produccion ?(
      <div className="container">
        <br />
        <br />
        <Row >

          <Col md={4} align="center">
            {user.menu_produccion ?(
            <Button href="/PedidosCreate" className="botonesMenu" color="success">
            <i class="fas fa-file-alt fa-7x"></i>
              <br />
              <br />
               Crear OP
            </Button>
            ): <Button disabled className="botonesMenu" color="success">
            <i class="fas fa-file-alt fa-7x"></i>
              <br />
              <br />
               Crear OP
            </Button> }
          </Col>

 <Col md={4} align="center">
            {user.menu_produccion ?(
            <Button href="/EntradaProcesosCreate" className="botonesMenu" color="success">
              <i class="fas fa-cube fa-7x"></i>
              <br />
              <br />
              Entrada Procesos
            </Button>
            ): <Button disabled className="botonesMenu" color="success">
            <i class="fas fa-cube fa-7x"></i>
              <br />
              <br />
              Entrada Procesos
            </Button> }
          </Col>
          <Col md={4} align="center">
            {user.menu_produccion ?(
            <Button href="/ListadoCortes" className="botonesMenu" color="success">
            <i class="fas fa-cut fa-7x"></i>
              <br />
              <br />
              Produccion
            </Button>
            ): <Button disabled className="botonesMenu" color="success">
            <i class="fas fa-cut fa-7x"></i>
              <br />
              <br />
              Produccion
            </Button> }
          </Col>

          
          </Row>
          <br />
          <Row>

          {/* <Col md={4} align="center">
            {user.menu_produccion ?(
            <Button href="/ListadoOrdenesCorte" className="botonesMenu" color="success">
            <i class="fas fa-cut fa-7x"></i>
              <br />
              <br />
              Entregar Tela
            </Button>
            ): <Button disabled className="botonesMenu" color="success">
            <i class="fas fa-cut fa-7x"></i>
              <br />
              <br />
              Entregar Tela
            </Button> }
          </Col> */}

          <Col md={4} align="center">
            {user.menu_produccion ?(
            <Button href="/CortesPendientesRecibir" className="botonesMenu" color="success">
              <i class="fas fa-tasks fa-7x"></i>
              <br />
              <br />
              Procesos Pendientes <br/> Recibir
            </Button>
            ): <Button disabled className="botonesMenu" color="success">
            <i class="fas fa-tasks fa-7x"></i>
              <br />
              <br />
              Procesos Pendientes <br/> Recibir
            </Button> }
          </Col>

        <Col md={4} align="center">
            {user.menu_produccion ?(
            <Button href="/Maquileros" className="botonesMenu" color="success">
            <i class="fas fa-dolly fa-7x"></i>
              <br />
              <br />
              Maquileros
            </Button>
            ): <Button disabled className="botonesMenu" color="success">
            <i class="fas fa-dolly fa-7x"></i>
              <br />
              <br />
              Maquileros
            </Button> }
          </Col>

          <Col md={4} align="center">
            {user.menu_produccion ?(
            <Button href="/CatalogoProcesos" className="botonesMenu" color="success">
            <i class="fas fa-list fa-7x"></i>
              <br />
              <br />
              Catalogo Procesos
            </Button>
            ): <Button disabled className="botonesMenu" color="success">
            <i class="fas fa-list fa-7x"></i>
              <br />
              <br />
              Catalogo Procesos
            </Button> }
          </Col>
          </Row>
          <br />
          <Row>
           

          {/* <Col md={4} align="center">
          {user.menu_produccion ?(
            <Button href="/ListadoApartados" className="botonesMenu" color="success">
              <i class="fas fa-people-carry fa-7x"></i>
              <br />
              <br />
              Apartados
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-people-carry fa-7x"></i>
          <br />
          <br />
          Apartados
        </Button> }
          </Col> */}

        </Row>
      </div>
      ): undefined } 
      
    </>
  );
}

export default BotonesProduccion;
